module.exports = __webpack_public_path__ + "static/media/vmware_logo.e3b1a3a2.svg";